import { createTheme, darken, lighten } from '@mui/material/styles';
// import { lightOrDark } from '@/js/shared/utils/detect';

// Defined using
// https://material.io/resources/color/#!/?view.left=0&view.right=0&primary.color=FFF3E0&secondary.color=FBC02D

const theme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 820,
      lg: 1280,
      xl: 1920,
    },
  },
  // overrides: {},
  typography: {
    fontFamily: 'Helvetica, Arial, sans-serif',
  },
  palette: {
    mode: 'dark',
    background: {
      shadeup_10: darken('#000000', 0.6),
      paper: lighten('#000000', 0.06),
      shadedown_10: lighten('#000000', 0.06),
      shadedown_20: lighten('#000000', 0.12),
      default: '#000000',
      // Paper is same as Coeo shade light
    },
    primary: {
      main: '#fbc02d',
    },
    secondary: {
      main: '#8f4a76',
    },
    text: {
      primary: '#ffffff',
      secondary: 'rgba(255, 255, 255, 0.7)',
      disabled: 'rgba(255, 255, 255, 0.5)',
      hint: 'rgba(255, 255, 255, 0.5)',
    },
  },
  shape: {
    borderRadius: 2,
  },
  shadows: Array(25).fill('none'),
  components: {
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: 4,
          fontSize: 16,
          '&.MuiInputBase-multiline': {
            padding: 10,
          },
        },
        input: {
          '&:not(.MuiInputBase-inputMultiline)': {
            boxSizing: 'content-box',
            height: 23,
            padding: 10,
            fontSize: 16,
          },
        },
        inputMultiline: {
          padding: 0,
          fontSize: 16,
        },
        inputAdornedStart: {
          paddingLeft: 0,
        },
      },
    },

    MuiSelect: {
      styleOverrides: {
        select: {
          '&.MuiOutlinedInput-input': {
            boxSizing: 'content-box',
            minHeight: 'unset',
            height: '23px',
            paddingTop: '10px',
            paddingBottom: '10px',
            paddingLeft: '10px',
            paddingRight: '32px',
            fontSize: 16,
          },
        },
      },
    },

    MuiInputLabel: {
      styleOverrides: {
        outlined: {
          '&:not(.MuiInputLabel-shrink)': {
            top: 0,
            transform: 'translate(14px, 10px) scale(1)',
          },
          '&.MuiInputLabel-shrink': {
            top: 0,
            transform: 'translate(14px, -9px) scale(0.75)',
          },
        },
      },
    },

    MuiAutocomplete: {
      styleOverrides: {
        inputRoot: {
          '&.MuiOutlinedInput-root': {
            padding: '10px',
            paddingRight: '39px',
          },
        },
        input: {
          '&.MuiOutlinedInput-input': {
            padding: 0,
          },
        },
      },
    },

    MuiInputAdornment: {
      styleOverrides: {
        root: {
          '& .MuiSvgIcon-root, & .material-icons': { fontSize: 20 },
        },
        positionStart: { marginLeft: 10 },
      },
    },
  },
});
export default theme;
